/**
 * Master kill switch for frontend Bugsnag.
 * Keep in sync with packages/ui/bugsnagFeatureEnabled.js (required by next.config).
 *
 * - false: Bugsnag is off in every environment
 * - true: only when APP_ENV is staging or production and BUGSNAG_API_KEY is set
 */
export const BUGSNAG_FEATURE_ENABLED = false;

/**
 * Whether frontend Bugsnag should initialize, report, or wrap ErrorBoundary.
 * Requires the master feature flag, an API key, and APP_ENV of staging or production
 * (same gate as the API Bugsnag client).
 */
export function isBugsnagActive(): boolean {
  if (!BUGSNAG_FEATURE_ENABLED) return false;
  if (!process.env.BUGSNAG_API_KEY) return false;

  const appEnv = process.env.APP_ENV;
  return appEnv === 'staging' || appEnv === 'production';
}
